import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine5HeadExtra10 extends ITextBoxProps {}

export const TextBoxMaxLine5HeadExtra10 = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.HeadlineExtra10,
  alignment = TextAligning.Left,
  maxLines = 5,
  ...rest
}: ITextBoxMaxLine5HeadExtra10): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
